import type { Flag } from '@atlassian/jira-flags';
import { messages as deleteSuccessMessages } from './delete/index.tsx';
import { messages as errorMessages } from './failure/index.tsx';
import { messages as successMessages } from './success/index.tsx';

export const successFlag = (): Flag => ({
	type: 'success',
	title: successMessages.title,
	description: successMessages.description,
	isAutoDismiss: false,
	delayAnnouncement: 3000,
	messageId: 'navigation-shortcuts.edit-shortcut-modal.flags.flag.success',
	messageType: 'transactional',
});

export const deleteSuccessFlag = (): Flag => ({
	type: 'success',
	title: deleteSuccessMessages.title,
	description: deleteSuccessMessages.description,
	isAutoDismiss: false,
	delayAnnouncement: 3000,
	messageId: 'navigation-shortcuts.edit-shortcut-modal.flags.flag.success.delete-success',
	messageType: 'transactional',
});

export const errorFlag = (): Flag => ({
	type: 'error',
	title: errorMessages.title,
	description: errorMessages.description,
	isAutoDismiss: false,
	delayAnnouncement: 3000,
	messageId: 'navigation-shortcuts.edit-shortcut-modal.flags.flag.error',
	messageType: 'transactional',
});
